<div class="mt-3 flex justify-center w-full">
  <button class=" bg-red-500 hover:bg-red-600 cursor-pointer text-white p-3 rounded-4xl"
  (click)="confirmation()">Eliminar cuenta</button>
</div>
<perfil-user-component-modal-confirmation-delete-account></perfil-user-component-modal-confirmation-delete-account>
